module.exports = __webpack_public_path__ + "images/thumb-eef0f4a5f3487e7f9008db668340a927.jpg";